<template>
  <span v-if="showBlank" />
  <span
    v-else-if="showDash"
    class="text-grey-7"
  >—</span>
  <i18n-n
    v-else
    :class="classes"
    tag="span"
    :value="cleanValue"
    :format="format"
    scope="global"
  />
</template>

<script>

export default {
  name: 'FormattedNumber',
  props: {
    value: {
      type: Number,
      required: true,
      default: null
    },
    autoColor: {
      type: Boolean,
      required: false,
      default: true
    },
    format: {
      type: String,
      required: false,
      default: 'currency'
    },
    zeroMode: {
      type: String,
      required: false,
      default: 'dash' // 'dash', 'blank', 'zero'
    }
  },
  computed: {
    showBlank () {
      if (this.zeroMode !== 'blank') return false

      if (!_.isNumber(this.cleanValue)) return true

      if (this.cleanValue === 0) return true

      return false
    },
    showDash () {
      if (this.zeroMode !== 'dash') return false

      if (!_.isNumber(this.cleanValue)) return true

      if (this.cleanValue === 0) return true

      return false
    },
    cleanValue () {
      if (_.includes(this.format, 'currency')) {
        // This cleans up strange javascript rounding errors and negative zeros
        return parseFloat((this.value + 0.00001).toFixed(2))
      } else {
        return this.value
      }
    },
    classes () {
      if (!this.autoColor) {
        return {}
      }

      return { 'text-grey-7': !this.cleanValue, 'text-red': this.cleanValue < 0 }
    }
  }
}

</script>
